module.exports = __webpack_public_path__ + "static/media/image3.8289c923.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Restaurant/images/image3.jpg
// module id = 373
// module chunks = 0